import {
  FETCH_LOGOUT_PENDING,
  FETCH_LOGOUT_SUCCESS,
  FETCH_LOGOUT_FAILED,
} from "../constants/Constants";

const initialState = {
  pending: false,
  data: [],
  error: "",
};

export const requestLogOutReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOGOUT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case FETCH_LOGOUT_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.payload,
      };
    case FETCH_LOGOUT_FAILED:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
